<template>
    <div class="pad:grid pad:grid-cols-2 pad:gap-4">
        <Card
            v-for="item in data"
            :key="item.fullPolicyNo"
            :cursorPointer="!disabled"
            :disabled="disabled"
            :tagText="item.memo"
            class="sm:max-w-[30rem] mb-4 last:mb-0 md:mb-0"
            @click="$emit('update:checkedRadio',item.policyNoSeqSrceFromIdDup)"
        >
            <template #title>
                <Radio
                    v-if="!disabled"
                    v-model:checkedValue="policyRadio"
                    :value="item.policyNoSeqSrceFromIdDup"
                    name="policy"
                    :text="item.fullPolicyNo"
                    radioType="2"
                    @click="$emit('update:checkedRadio',item.policyNoSeqSrceFromIdDup)"
                />
                <span v-else>
                    {{ item.fullPolicyNo }}
                </span>
            </template>
            <template #topContent>
                <CardSubtitle
                    :text="item.itemName"
                    :disabled="disabled"
                />
                <CardRow
                    label="目前繳費方式"
                    :value="item.payKindText"
                    :disabled="disabled"
                />
            </template>
            <template #foldContent>
                <CardRow
                    label="被保險人"
                    :value="item.name"
                    :disabled="disabled"
                />
                <CardRow
                    label="幣別"
                    :value="item.currencyText"
                    :disabled="disabled"
                />
            </template>
            <template #bottomContent>
                <div
                    :class="[disabled?'text-gray-200':'text-warning',item.memoList.length>=1?'block':'hidden']"
                    class="py-1.5 px-2.5 min-h-[2.5rem] text-sm xs:text-base"
                >
                    <ul
                        v-if="item.memoList.length===2"
                        class="list-disc list-inside"
                    >
                        <li>{{ item.memoList[0] }}</li>
                        <li>{{ item.memoList[1] }}</li>
                    </ul>
                    <p v-else>
                        {{ item.memoList[0] }}
                    </p>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import { toRef } from 'vue';
import Radio from '@/components/radios/Radio.vue';
import Card from '@/components/card/CardPolicyBase.vue';
import CardRow from '@/components/card/CardRow.vue';
import CardSubtitle from '@/components/card/CardSubtitle.vue';

export default {
    components: {
        Card,
        Radio,
        CardRow,
        CardSubtitle
    },
    props: {
        checkedRadio: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:checkedRadio'],
    setup(props) {
        const policyRadio = toRef(props, 'checkedRadio');
        return {
            policyRadio
        };
    },
};
</script>
